import { Checkbox, CheckboxGroup } from '@ygtechnologies/rubus-ui';
import React from 'react';
import { ProjectFeeSet } from '@/types';
import { toggleValue } from '@ygtechnologies/rubus-frontend-utilities';
import { classnames } from '@/utils/html';
import theme from './ProjectFeeSetPermissionsEditor.module.scss';

interface ProjectFeeSetPermissionsEditorProps {
    projectFeeSets: ProjectFeeSet[];
    value: number[];
    onChange(newValue: number[]): void;
}

const ProjectFeeSetPermissionsEditor: React.FC<ProjectFeeSetPermissionsEditorProps> = ({
    projectFeeSets,
    value,
    onChange,
}) => {
    const handleChange = (e, pfs: ProjectFeeSet) => {
        const newValue = toggleValue(value, pfs.id, e.target.checked);
        onChange(newValue);
    };

    return (
        <CheckboxGroup>
            {projectFeeSets.map((pfs) => (
                <Checkbox
                    key={pfs.id}
                    checked={value.includes(pfs.id)}
                    onChange={(e) => handleChange(e, pfs)}
                    inputSize="md">
                    {pfs.name}
                </Checkbox>
            ))}
        </CheckboxGroup>
    );
};

export default ProjectFeeSetPermissionsEditor;
